import moment from 'moment';
import { IOfficialDiaryPagedRequest } from '../../../../model/sdp/official-daily/request/official-diary-paged-request';

export type OfficialDiarySearchState = {
  datesParameters: {
    starDatePicker: moment.Moment;
    endDatePicker: moment.Moment;
  };
  parameters: IOfficialDiaryPagedRequest;
};

export enum ACTION_TYPES {
  setDatesParameters = 'setDatesParameters',
  setParameters = 'setParameters',
  updateParameter = 'updateParameter',
}

export const OfficialDiarySearchReducer = (state: OfficialDiarySearchState, action: any): OfficialDiarySearchState => {
  const { type, payload } = action;
  switch (type) {
    case ACTION_TYPES.setDatesParameters:
      return {
        ...state,
        datesParameters: payload,
      };
    case ACTION_TYPES.setParameters:
      return {
        ...state,
        parameters: payload,
      };
    case ACTION_TYPES.updateParameter:
      return {
        ...state,
        parameters: {
          ...state.parameters,
          ...payload,
        },
      };
    default:
      throw new Error(`Unhandled action type: ${type}`);
  }
}
